import {PinProtect} from '~/features/Auth/PinProtect';

import {SystemHealth} from '~/features/SystemHealth';

export const SystemHealthScene = () => {
  return (
    <div className="bg-background min-h-screen">
      <PinProtect>
        <SystemHealth />
      </PinProtect>
    </div>
  );
};
